import React from 'react';
import SeasonForm from '../../../components/season/season-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as seasonsActions from '../../../actions/seasons';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';
import LocalizedStrings from '../../../localization/strings';

class SeasonContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/seasons';
    }

    fetchItem(id) {
        return this.props.actions.fetchSeason(id)
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.seasonEdit}</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <SeasonForm submit={actions.submitSeason} onSuccessSubmit={this.onSuccessSubmit.bind(this)}></SeasonForm>
}
                </div>
            </div>
        )

    }
}

export default connect(function(state) {
    return {loading: state.season.season.loading};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...seasonsActions
        }, dispatch)
    };
})(SeasonContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/season/season-container.js